// extracted by mini-css-extract-plugin
module.exports = {"displayLineBreaks":"CancellationPolicy_displayLineBreaks__z2zLo"};